// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3eeead25","455":"a9a12a35","977":"228b6fde"}[chunkId] + ".chunk.js";
};